import i18n from 'sveltekit-i18n';

import de from './de';
import es from './es';
import en from './en';
import fr from './fr';
import it from './it';
import ko from './ko';
import ja from './ja';

const config = {
	fallbackLocale: 'en',
	loaders: [de, es, en, fr, it, ko, ja].flatMap((locale) => [
		{
			locale: locale.name,
			key: 'common',
			loader: async () => locale.common
		},
		{
			locale: locale.name,
			key: 'page.home',
			routes: ['/'],
			loader: async () => locale.home
		},
		{
			locale: locale.name,
			key: 'page.contact',
			routes: ['/contact-us'],
			loader: async () => locale.contact
		},
		{
			locale: locale.name,
			key: 'page.content',
			routes: ['/content', /\/content\/.*\/.*/],
			loader: async () => locale.content
		},
		{
			locale: locale.name,
			key: 'page.search',
			routes: ['/search'],
			loader: async () => locale.search
		},
		{
			locale: locale.name,
			key: 'page.vendors',
			routes: ['/vendors'],
			loader: async () => locale.vendors
		},
		{
			locale: locale.name,
			key: 'page.publishers',
			routes: ['/publishers'],
			loader: async () => locale.publishers
		},
		{
			locale: locale.name,
			key: 'page.about',
			routes: ['/about-us'],
			loader: async () => locale.about
		},
		{
			locale: locale.name,
			key: 'page.work-together',
			routes: ['/work-with-us'],
			loader: async () => locale.workTogether
		},
		{
			locale: locale.name,
			key: 'page.filters',
			routes: ['/category', '/type', '/format'],
			loader: async () => locale.filters
		}
	])
};

export const { t, locale, locales, loading, loadTranslations } = new i18n(config);
